import React, { useContext, useMemo, useCallback } from 'react';
import {
  BEDSIDE_MANNER,
  WAIT_TIME,
  AUDIO_VIDEO_QUALITY,
  STAFF_FRIENDLINESS_OPTIONAL,
  OFFICE_ENVIRONMENT,
  STAFF_FRIENDLINESS,
  QUALITY_OF_CARE,
} from '../../../../components/LeaveAReview/constants';
import { ADD_REVIEW_UNGATED, ADD_REVIEW_TO_SOLV } from '../../../../constants';
import { analyticsTrackEvent } from '../../../../core/analytics';
import {
  ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE,
  ADD_REVIEW_LEAVE_REVIEW_ON_SOLV,
} from '../../../../core/analytics/events';
import {
  isExternalTelemedBooking,
  isProviderGroupBooking,
  isTelemedBooking,
} from '../../../../core/util/booking';
import { ReviewContext } from '../../context';
import ReviewOnSolvCollector from '../../steps/ReviewOnSolvCollector';
import ThankYou from '../../steps/ThankYou';
import GoogleOrSolv from './GoogleOrSolv';
import { goToGoogleReviewFlow } from '~/core/dapi/tracking';

const UngatedReview = () => {
  const context = useContext(ReviewContext)!;
  const { booking, googleUrl, starRating, review, bookingId, location, setFlowState } = context;

  const trackingProperties = useMemo(
    () => ({
      locationId: location.id,
      flowType: ADD_REVIEW_UNGATED,
      starRating,
      review,
      bookingId,
    }),
    [bookingId, location.id, review, starRating]
  );

  const handleReviewOnGoogle = useCallback(async () => {
    analyticsTrackEvent(ADD_REVIEW_LEAVE_REVIEW_ON_GOOGLE, trackingProperties);

    goToGoogleReviewFlow(googleUrl, bookingId);
  }, [googleUrl, trackingProperties]);

  const handleReviewOnSolv = useCallback(() => {
    analyticsTrackEvent(ADD_REVIEW_LEAVE_REVIEW_ON_SOLV, trackingProperties);
    setFlowState(ADD_REVIEW_TO_SOLV);
  }, [setFlowState, trackingProperties]);

  const secondaryRatings = useMemo(() => {
    if (isProviderGroupBooking(booking)) {
      if (isExternalTelemedBooking(booking)) {
        return [BEDSIDE_MANNER, WAIT_TIME, AUDIO_VIDEO_QUALITY, STAFF_FRIENDLINESS_OPTIONAL];
      }
      return [BEDSIDE_MANNER, WAIT_TIME, OFFICE_ENVIRONMENT, STAFF_FRIENDLINESS];
    }
    if (isTelemedBooking(booking)) {
      return [WAIT_TIME, QUALITY_OF_CARE, BEDSIDE_MANNER, STAFF_FRIENDLINESS];
    }
    return [WAIT_TIME, QUALITY_OF_CARE, BEDSIDE_MANNER, STAFF_FRIENDLINESS, OFFICE_ENVIRONMENT];
  }, [booking]);

  return (
    <>
      <GoogleOrSolv reviewOnGoogle={handleReviewOnGoogle} reviewOnSolv={handleReviewOnSolv} />
      <ReviewOnSolvCollector {...context} secondaryRatings={secondaryRatings} />
      <ThankYou {...context} />
    </>
  );
};

export default UngatedReview;
